'use strict';

const { showToastMessage } = require('./toast');

module.exports = function () {
    const alertLauncherList = document.querySelectorAll('.js-sticky-alert-launcher');

    function launchAlert(el) {
        const {
            alertContainerSelector = '.feedback-element',
            alertType = 'alert-danger',
            alertId = '',
            alertClass = '',
            alertQa = '',
            alertMessage = 'error',
            alertDisableAutoClosing = false,
            alertDisableCloseButton = false
        } = el.dataset;

        showToastMessage({
            containerSelector: alertContainerSelector,
            alertType: alertType,
            alertId: alertId,
            alertClass: alertClass,
            alertQa: alertQa,
            message: alertMessage,
            disableAutoClosing: alertDisableAutoClosing === 'true',
            disableCloseButton: alertDisableCloseButton === 'true'
        });
    }

    alertLauncherList.forEach(alertLauncher => launchAlert(alertLauncher));
};
